<div class="wl-backlog">
  <!-- Barra de filtros -->
  <div class="wl-filters">
    <p-dropdown [options]="typeOptions" [(ngModel)]="filterType" (onChange)="reload()" optionLabel="label"
      optionValue="value" placeholder="Tipo" [showClear]="true" styleClass="wl-f"></p-dropdown>
    <p-dropdown [options]="areaOptions" [(ngModel)]="filterArea" (onChange)="reload()" optionLabel="label"
      optionValue="value" placeholder="Área" [showClear]="true" styleClass="wl-f"></p-dropdown>
    <p-dropdown [options]="priorityOptions" [(ngModel)]="filterPriority" (onChange)="reload()" optionLabel="label"
      optionValue="value" placeholder="Prioridad" [showClear]="true" styleClass="wl-f"></p-dropdown>
    <!-- Sustituye a la pestaña «Mis tareas»: la pregunta de quien reporta vive aquí, junto al
         resto de filtros, en vez de en una pantalla aparte. -->
    <button type="button" class="wl-mine" [class.on]="filterMine" (click)="filterMine = !filterMine; reload()"
      title="Solo las tareas que yo reporté">
      <i class="fa-solid fa-user-check"></i> Solo las mías
    </button>
    <button type="button" class="wl-clear" *ngIf="hasFilters" (click)="clearFilters()">
      <i class="fa-solid fa-xmark"></i> Limpiar
    </button>
    <!-- Con filtros activos el conteo es honesto: lo visible sobre el total real. -->
    <!-- Mientras carga no se cuenta: un «0 en backlog» junto al skeleton afirma que no hay nada
         cuando lo cierto es que todavía no se sabe. -->
    <ng-container *ngIf="!loading">
      <span class="wl-count" *ngIf="hasFilters; else totalCount">{{ pool.length }} de {{ poolTotal }} en backlog</span>
      <ng-template #totalCount><span class="wl-count">{{ poolTotal }} en backlog</span></ng-template>
    </ng-container>
  </div>

  <!-- Con un filtro puesto la lista no es la lista: reordenar ahí calcularía la posición contra
       vecinos que no se están viendo. Se dice, en vez de dejar que el arrastre mienta. -->
  <div class="wl-note" *ngIf="canPrioritize && hasFilters">
    <i class="fa-solid fa-circle-info"></i> Quita los filtros para reordenar: la posición se calcula contra la lista completa.
  </div>

  <!-- Loading -->
  <!-- Skeleton con la forma de una fila del backlog: tipo, título, etiquetas y los chips de la
       derecha. Reserva el alto real, así la lista no salta al llegar el dato. -->
  <div class="sk-list" *ngIf="loading" aria-busy="true" aria-label="Cargando backlog">
    <div class="sk-row" *ngFor="let i of [1,2,3,4,5,6]" [ngClass]="'sk-fade-' + (i > 4 ? 4 : i)">
      <p-skeleton shape="circle" size="1.1rem"></p-skeleton>
      <div class="sk-main">
        <p-skeleton height="0.85rem" [width]="i % 3 === 0 ? '38%' : i % 2 === 0 ? '62%' : '50%'"></p-skeleton>
        <p-skeleton height="0.6rem" width="5.5rem" borderRadius="999px"></p-skeleton>
      </div>
      <div class="sk-right">
        <p-skeleton height="0.7rem" width="3.2rem" borderRadius="999px"></p-skeleton>
        <p-skeleton shape="circle" size="1.5rem"></p-skeleton>
        <p-skeleton height="0.7rem" width="3rem"></p-skeleton>
      </div>
    </div>
  </div>

  <ng-container *ngIf="!loading">
    <!-- ── Cubeta: Siguiente sprint (comprometidas, priorizadas por el Admin) ── -->
    <div class="wl-bucket" *ngIf="next.length || canPrioritize">
      <div class="wl-bucket-head next">
        <span class="wl-bucket-name"><i class="fa-solid fa-forward"></i> Siguiente sprint</span>
        <span class="wl-bucket-hint">{{ canDrag ? 'Arrastra aquí para comprometer · el orden es la prioridad' : 'Comprometidas y en orden de atención' }}</span>
        <span class="wl-bucket-count">{{ next.length }}</span>
      </div>
      <div class="wl-list" *ngIf="next.length" [class.is-dragging]="!!dragged">
        <ng-container *ngFor="let g of nextGroups; trackBy: trackGroup">
          <ng-container *ngTemplateOutlet="group; context: { g: g, bucket: 'next' }"></ng-container>
        </ng-container>
        <ng-container *ngTemplateOutlet="dropEnd; context: { bucket: 'next' }"></ng-container>
      </div>
      <!-- La cubeta vacía es el primer destino posible: si no acepta el soltar, la promoción por
           arrastre no existe hasta que alguien logre meter la primera por otra vía. -->
      <div class="wl-bucket-empty" *ngIf="!next.length" pDroppable="backlog" [pDroppableDisabled]="!canDrag"
        [class.on]="dropEndBucket === 'next'" (onDragEnter)="onEnterEnd('next')" (onDrop)="onDropEnd('next')">
        {{ dragged ? 'Suelta aquí para comprometerla al siguiente sprint' : 'Nada comprometido aún — arrastra tareas desde el backlog.' }}
      </div>
    </div>

    <!-- ── Cubeta: Backlog (pool sin priorizar) ── -->
    <div class="wl-bucket">
      <div class="wl-bucket-head">
        <span class="wl-bucket-name"><i class="fa-solid fa-inbox"></i> Backlog</span>
        <span class="wl-bucket-hint">{{ canDrag ? 'Arrastra para ordenar · lo de arriba se atiende antes' : 'Todo lo reportado, aún sin priorizar' }}</span>
        <span class="wl-bucket-count">{{ pool.length }}</span>
      </div>
      <div class="wl-list" *ngIf="pool.length" [class.is-dragging]="!!dragged">
        <ng-container *ngFor="let g of poolGroups; trackBy: trackGroup">
          <ng-container *ngTemplateOutlet="group; context: { g: g, bucket: 'pool' }"></ng-container>
        </ng-container>
        <ng-container *ngTemplateOutlet="dropEnd; context: { bucket: 'pool' }"></ng-container>
      </div>
      <div class="wl-state" *ngIf="!pool.length">
        <i class="fa-solid fa-inbox"></i>
        <p>No hay tareas en el backlog con estos filtros.</p>
      </div>
    </div>
  </ng-container>

  <!-- Un BLOQUE: la épica con sus tareas, o una tarea suelta.
       Lo que se arrastra es esto, no la fila: mover una tarea dentro de su épica no significa nada
       y mover la épica sí. Por eso el asa y los eventos de arrastre viven en la cabecera. -->
  <ng-template #group let-g="g" let-bucket="bucket">
    <!-- Tarea suelta: la fila ES el bloque, y se ve exactamente como siempre. -->
    <ng-container *ngIf="g.kind === 'loose'">
      <ng-container *ngTemplateOutlet="row; context: { it: g.items[0], g: g, bucket: bucket }"></ng-container>
    </ng-container>

    <ng-container *ngIf="g.kind === 'epic'">
      <div class="wl-epic"
        pDraggable="backlog" [pDraggableDisabled]="!canDrag"
        pDroppable="backlog" [pDroppableDisabled]="!canDrag"
        [class.is-draggable]="canDrag"
        [class.is-dragged]="dragged?.key === g.key"
        [class.is-drop-before]="dropBeforeKey === g.key"
        [class.is-open]="isExpanded(g)"
        (onDragStart)="onDragStart(g)"
        (onDragEnd)="onDragEnd()"
        (onDragEnter)="onEnterRow(g)"
        (onDrop)="onDropBefore(g, bucket)"
        (click)="toggleEpic(g)"
        (keydown)="onRowKey($event, g, bucket)"
        [attr.tabindex]="canDrag ? 0 : null"
        [attr.aria-expanded]="isExpanded(g)"
        [attr.aria-label]="(isExpanded(g) ? 'Ocultar' : 'Ver') + ' las tareas de ' + g.title">
        <span class="wl-grip" *ngIf="canDrag" title="Arrastra la épica completa"><i class="fa-solid fa-grip-vertical"></i></span>
        <i class="fa-solid wl-epic-chevron" [class.fa-chevron-down]="isExpanded(g)" [class.fa-chevron-right]="!isExpanded(g)"></i>
        <span class="wl-epic-icon"><i class="fa-solid fa-layer-group"></i></span>
        <div class="wl-epic-main">
          <span class="wl-epic-title">{{ g.title }}</span>
          <span class="wl-epic-sub">
            <span class="wl-epic-dot" *ngIf="g.statusColor" [style.background]="g.statusColor"></span>
            {{ groupMeta(g) }}
          </span>
        </div>
      </div>

      <div class="wl-epic-tasks" *ngIf="isExpanded(g)">
        <ng-container *ngFor="let it of g.items; trackBy: trackId">
          <ng-container *ngTemplateOutlet="row; context: { it: it, g: g, bucket: bucket, inEpic: true }"></ng-container>
        </ng-container>
      </div>
    </ng-container>
  </ng-template>

  <!-- Fila compartida por ambas cubetas.
       Se arrastra desde cualquier punto (mismo patrón que las tarjetas del Tablero): el chip de
       estimación ya detiene su propio clic, y un clic sin desplazamiento no dispara un drag. -->
  <ng-template #row let-it="it" let-g="g" let-bucket="bucket" let-inEpic="inEpic">
    <!-- Dentro de una épica la fila NO se arrastra: el orden interno no decide nada y se resuelve
         en el Tablero. Suelta, la fila ES el bloque y conserva el arrastre de siempre. -->
    <div class="wl-row"
      [class.is-in-epic]="inEpic"
      pDraggable="backlog" [pDraggableDisabled]="!canDrag || inEpic"
      pDroppable="backlog" [pDroppableDisabled]="!canDrag || inEpic"
      [class.is-draggable]="canDrag && !inEpic"
      [class.is-dragged]="!inEpic && dragged?.key === g?.key"
      [class.is-drop-before]="!inEpic && dropBeforeKey === g?.key"
      (onDragStart)="!inEpic && onDragStart(g)"
      (onDragEnd)="onDragEnd()"
      (onDragEnter)="!inEpic && onEnterRow(g)"
      (onDrop)="!inEpic && onDropBefore(g, bucket)"
      (click)="openDetail(it)"
      (keydown)="!inEpic && onRowKey($event, g, bucket)"
      [attr.tabindex]="canDrag && !inEpic ? 0 : null"
      [attr.role]="canDrag ? 'button' : null"
      [attr.aria-label]="canDrag ? rowAria(it, g, bucket) : null">

      <!-- Asa: no es obligatoria para arrastrar (la fila entera lo es), pero es lo que anuncia
           que se puede. Sin ella el arrastre queda escondido, que es lo que pasaba con los
           botones de flechas: había que descubrirlos. -->
      <span class="wl-grip" *ngIf="canDrag && !inEpic" aria-hidden="true"><i class="fa-solid fa-grip-vertical"></i></span>

      <span class="wl-row-type" [style.color]="typeMeta(it).color" [title]="typeMeta(it).label">
        <i [class]="typeMeta(it).icon"></i>
      </span>

      <div class="wl-row-main">
        <span class="wl-row-title"><span class="wl-code" *ngIf="it.code">{{ it.code }}</span>{{ it.title }}</span>
        <div class="wl-row-tags">
          <span class="wl-area" *ngFor="let a of it.areas" [style.background]="areaMeta(a)?.color + '1a'"
            [style.color]="areaMeta(a)?.color">
            <i [class]="areaMeta(a)?.icon"></i> {{ areaMeta(a)?.short }}
          </span>
          <span class="wl-origin" *ngIf="it.origin === 'proposed'" [style.color]="ORIGIN_META.proposed.color"
            [title]="ORIGIN_META.proposed.label">
            <i [class]="ORIGIN_META.proposed.icon"></i>
          </span>
          <!-- Fecha fija pedida por quien reporta: se ve desde la lista, con su motivo al pasar. -->
          <span class="wl-reqdue" *ngIf="it.requestedDueDate" [title]="'Fecha fija: ' + (it.requestedDueReason || 'sin motivo')">
            <i class="fa-solid fa-clock"></i> {{ it.requestedDueDate | date: 'dd MMM' }}
          </span>
        </div>
      </div>

      <span class="wl-sev" *ngIf="it.type === 'bug' && sevMeta(it)" [style.color]="sevMeta(it)?.color">
        {{ sevMeta(it)?.label }}
      </span>

      <span class="wl-prio" *ngIf="prioMeta(it)" [style.color]="prioMeta(it)?.color"
        [title]="'Prioridad ' + prioMeta(it)?.label">
        <i [class]="prioMeta(it)?.icon"></i> {{ prioMeta(it)?.label }}
      </span>

      <span class="wl-pts" *ngIf="it.points != null">{{ it.points }} pts</span>

      <!-- Estimación de lo comprometido: solo en la cubeta del siguiente sprint, que es donde
           significa algo (es la línea base del burndown). -->
      <span class="wl-est" *ngIf="bucket === 'next'" (click)="$event.stopPropagation()">
        <button type="button" class="wl-est-chip" [class.set]="it.estimatedPoints != null" [disabled]="!isDev"
          [title]="isDev ? 'Estimar el esfuerzo' : 'Estimación del equipo'"
          (click)="estimating = it; estPanel.toggle($event)">
          {{ it.estimatedPoints != null ? it.estimatedPoints + ' est.' : 'estimar' }}
        </button>
      </span>

      <span class="wl-req" [title]="'Solicitó: ' + userName(it.createdBy)">
        <span class="ava">{{ initials(it.createdBy) }}</span>
      </span>

      <span class="wl-date">{{ it.createdAt | date: 'dd MMM' }}</span>

      <i class="fa-solid fa-chevron-right wl-chev"></i>
    </div>
  </ng-template>

  <!-- Zona de cola: solo existe mientras se arrastra. Sin ella no hay forma de soltar «al final»,
       porque cada fila inserta ANTES de sí misma. -->
  <ng-template #dropEnd let-bucket="bucket">
    <div class="wl-drop-end" *ngIf="dragged" pDroppable="backlog"
      [class.on]="dropEndBucket === bucket"
      (onDragEnter)="onEnterEnd(bucket)"
      (onDrop)="onDropEnd(bucket)"></div>
  </ng-template>

  <!-- Escala Fibonacci compartida por todas las filas: una sola instancia, no una por tarea. -->
  <p-overlayPanel #estPanel styleClass="wl-est-panel" appendTo="body">
    <ng-template pTemplate>
      <span class="wl-est-title">Esfuerzo estimado</span>
      <div class="wl-est-opts">
        <button type="button" *ngFor="let p of EFFORT_POINTS" [title]="p.hint"
          [class.on]="estimating?.estimatedPoints === p.value"
          (click)="estimate(estimating!, p.value); estPanel.hide()">{{ p.value }}</button>
      </div>
    </ng-template>
  </p-overlayPanel>
</div>
